import { Injectable } from '@angular/core';

import MeetingAttendeeSummary from 'entity/MeetingAttendeeSummary';
import MeetingHostSummary from 'entity/MeetingHostSummary';
import User from 'entity/User';
import MeetingSummaryController from 'rest/MeetingSummaryController';
import Paging from 'rest/Paging';

@Injectable({
  providedIn: 'root',
})
export class MeetingSummaryService {
  private meetingSummaryController: MeetingSummaryController;

  public constructor() {
    this.meetingSummaryController = new MeetingSummaryController();
  }

  public getAttendeeSummary(attendeeSummaryId: string): Promise<MeetingAttendeeSummary> {
    return this.meetingSummaryController.getAttendeeSummary(attendeeSummaryId);
  }

  public getHostSummary(hostSummaryId: string): Promise<MeetingHostSummary> {
    return this.meetingSummaryController.getHostSummary(hostSummaryId);
  }

  public getHostSummaryShareUsers(hostSummaryId: string, page?: Paging): Promise<User[]> {
    return this.meetingSummaryController.getHostSummaryShareUsers(hostSummaryId, page);
  }

  public shareHostSummary(hostSummaryId: string, userIds: string[]): Promise<void> {
    return this.meetingSummaryController.shareHostSummary(hostSummaryId, userIds);
  }

  public unshareHostSummary(hostSummaryId: string, userId: string): Promise<void> {
    return this.meetingSummaryController.unshareHostSummary(hostSummaryId, userId);
  }

  public getHostSummaryList(search?: string, page?: Paging): Promise<MeetingHostSummary[]> {
    return this.meetingSummaryController.getHostSummaries(search, page);
  }

  public getAttendeeSummaryList(page?: Paging): Promise<MeetingAttendeeSummary[]> {
    return this.meetingSummaryController.getAttendeeSummaries(page);
  }

  public registerForAttendeeSummary(socialRoomSetId: string, email: string): Promise<string> {
    return this.meetingSummaryController.registerForAttendeeSummary(socialRoomSetId, email);
  }
}
